import useChannelInitialization from 'gcs-common/hooks/useChannelInitialization';
import { getChannelListChannelIds } from 'gcs-common/slices/channels/channelsSelectors';
import { useSelector } from 'react-redux';
import Chat from '../Chat/Chat';
import ChatNavBar from '../ChatNavBar/ChatNavBar';
import styles from './styles.module.scss';

function ChatWrapper() {
  const allChannels = useSelector(getChannelListChannelIds) as string[];
  const hasChannels = !!allChannels?.length;

  useChannelInitialization();

  return (
    <div className={styles.chatWrapper}>
      {hasChannels && (
        <>
          <ChatNavBar />
          <Chat />
        </>
      )}
    </div>
  );
}

export default ChatWrapper;
